import React, { useState } from 'react';
import { useAutoHedgeContext } from '../contexts/AutoHedgeContext';

export const AutoHedgeConnect = () => {
  const { connectAccount, connectedAccounts, isLoading } = useAutoHedgeContext();
  const [selectedExchange, setSelectedExchange] = useState(null);

  console.log('🔗 AutoHedgeConnect RENDER:', {
    connectedAccounts: connectedAccounts.length,
    isLoading,
    selectedExchange
  });

  const exchangeProviders = [
    { 
      id: 'okx', 
      name: 'OKX', 
      logo: '⚡', 
      color: 'bg-blue-600 hover:bg-blue-700',
      description: 'Demo trading with 125x leverage',
      features: ['125x Leverage', 'Perpetual Futures', 'Real-time Data']
    },
    { 
      id: 'binance', 
      name: 'Binance', 
      logo: '🟡', 
      color: 'bg-yellow-600 hover:bg-yellow-700',
      description: 'Largest crypto futures exchange',
      features: ['125x Leverage', 'Highest Volume', 'Advanced Tools']
    },
    { 
      id: 'kraken', 
      name: 'Kraken', 
      logo: '🔱', 
      color: 'bg-purple-600 hover:bg-purple-700',
      description: 'Regulated and secure trading',
      features: ['50x Leverage', 'Regulated', 'Professional Grade']
    }
  ];

  const handleConnect = async (exchangeId) => {
    setSelectedExchange(exchangeId);
    try {
      console.log(`🔗 AutoHedgeConnect: Calling CONTEXT connectAccount for ${exchangeId}`);
      const result = await connectAccount(exchangeId);
      console.log(`✅ AutoHedgeConnect: CONTEXT connection successful for ${exchangeId}`, result);
    } catch (error) {
      console.error('❌ AutoHedgeConnect: CONTEXT connection failed:', error);
    } finally {
      setSelectedExchange(null);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-8">
        <h3 className="text-white text-2xl font-bold mb-4">
          Connect Demo Trading Account
        </h3>
        <p className="text-gray-400">
          Connect to a demo environment for risk-free auto hedging
        </p>
        <div className="text-xs text-blue-400 mt-2">
          Context Status: {connectedAccounts.length} accounts connected
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {exchangeProviders.map((provider) => (
          <div
            key={provider.id}
            className="bg-atticus-navy-800 rounded-xl p-4 border border-atticus-navy-700"
          >
            <div className="text-center mb-4">
              <div className="text-4xl mb-2">{provider.logo}</div>
              <h4 className="text-white font-bold text-lg">{provider.name}</h4>
              <p className="text-gray-400 text-sm">{provider.description}</p>
            </div>
            
            <div className="space-y-2 mb-4">
              {provider.features.map((feature, index) => (
                <div key={index} className="text-xs text-gray-300 flex items-center">
                  <span className="text-green-400 mr-2">✓</span>
                  {feature}
                </div>
              ))}
            </div>
            
            <button
              onClick={() => handleConnect(provider.id)}
              disabled={isLoading}
              className={`w-full ${provider.color} disabled:bg-gray-600 text-white py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center`}
            >
              {isLoading && selectedExchange === provider.id ? (
                <>
                  <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                  Connecting...
                </>
              ) : (
                `Connect ${provider.name}`
              )}
            </button>
          </div>
        ))}
      </div>
      
      <div className="bg-green-500/20 border border-green-500/50 rounded-xl p-4">
        <div className="text-green-400 text-sm text-center">
          🛡️ Demo Mode Only - No real funds at risk. 
          All trading is simulated for safe testing.
        </div>
      </div>
    </div>
  );
};
